import { Pathnames, defineRouting } from "next-intl/routing";
import { REFRESH_TOKEN_MAX_AGE } from "@/constants/cookies";

export const locales = ["en", "ro"] as const;

export const pathnames = {
  "/": "/",
  "/pathnames": "/pathnames",
  "/sign-up": "/sign-up",
  "/venues": "/venues",
  "/venues/register": "/venues/register",
  "/venues/[venueId]/overview": "/venues/[venueId]/overview",
  "/venues/[venueId]/facilities": "/venues/[venueId]/facilities",
  "/venues/[venueId]/reservations": "/venues/[venueId]/reservations",
  "/venues/[venueId]/reserve": "/venues/[venueId]/reserve",
  "/venues/[venueId]/info": "/venues/[venueId]/info",
  "/venues/[venueId]/subscription": "/venues/[venueId]/subscription",
  "/facilities/create": "/facilities/create",
  "/facilities/[facilityId]/overview": "/facilities/[facilityId]/overview",
  "/home": "/home",
  "/choose-role": "/choose-role",
  "/profile": "/profile",
  "/browse": "/browse",
  "/contact": "/contact",
  "/docs/terms": "/docs/terms",
  "/docs/privacy": "/docs/privacy",
  "/reports": "/reports",
  // Admin contact inbox. Registered so the subscriptions page can link to it
  // with the locale-aware Link; access is still gated by roleAccessConfig and
  // the page's own admin guard.
  "/contact-messages": "/contact-messages",
  // Public marketing routes. Registered so MarketingNavBar can link to them
  // with the locale-aware Link instead of emitting unprefixed hrefs that cost
  // a 307 on every click.
  "/pricing": "/pricing",
  "/pre-registration": "/pre-registration",
  "/faq": "/faq",
} satisfies Pathnames<typeof locales>;

// Use the default: `always`
export const localePrefix = undefined;

export const routing = defineRouting({
  locales,
  defaultLocale: 'ro',
  pathnames,
  localePrefix,
  alternateLinks: false,
  localeCookie: {
    name: 'NEXT_LOCALE',
    maxAge: REFRESH_TOKEN_MAX_AGE,
  }
});

export type AppPathnames = keyof typeof pathnames;
